import { useState, useEffect, useRef } from "react";
import { Button, Form, Radio,Input } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import * as Components from "../../components";
import { PaymentTypes } from "../../data";
import { groupBy, owntoast,PHONENO_VALIDATOR } from "../../utils";
import { useReactToPrint } from "react-to-print";
import {
  SaleType,
  ReceiptType,
  PaperSize,
  PaymentType,
} from "../../utils/enums";
import { SaleBill } from "../SaleBill";
/* Захиалгийн нийт дүн болон төрлүүд */
function OrderPayment(props) {
  const orderRef = useRef();
  const [billType, setBillType] = useState(1);
  const [disabled, setdDisabled] = useState(false);
  const [isNoat, setIsNoat] = useState(0);
  const [form] = Form.useForm();
  const [modalForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const { saleList, resordertypelist, order } = props;
  const getSum = () => saleList.reduce((a, v) => (a = a + v.amount), 0);
  const [isOpen, setIsOpen] = useState(false);
  const [activePaymentType, setPaymentType] = useState(1);
  const [payments, setPayments] = useState([]);
  const orderTypeData = resordertypelist
    ? groupBy(resordertypelist, "enumid")
    : {};
  const getPayedSum = () => payments.reduce((a, v) => (a = a + v.amount), 0);
  const print = ({ data, type }) => {
    if (data) {
      let body = {
        ...data,
        type: type,
        vatname: props._auth.vatname,
        foodsname: props._auth.foodsname,
        regno: props._auth.regno,
        username: props._auth.username,
        printqty: 1,
        footer: props.resprinterconfig && props.resprinterconfig.footer,
      };
      if (props.rescheckService === true) {
        sendPrintRequest(body);
      } else {
        setReceiptData(body);
      }
    }
  };

  const sendPrintRequest = (body) => {
    props.request({
      url: `/print/${
        props.resprinterconfig && props.resprinterconfig.printertype
          ? props.resprinterconfig.printertype
          : PaperSize.m58
      }`,
      body: body,
      method: "POST",
      isservice: true,
    });
  };

  const printOrder = useReactToPrint({
    content: () => orderRef.current,
  });

  useEffect(() => {
    if (receiptData && Object.keys(receiptData).length > 0) printOrder();
  }, [receiptData]);

  useEffect(() => {
    if (isOpen) {
      let sum = getSum();
      let payedSum = getPayedSum();
      let value = sum - payedSum;
      modalForm.setFieldsValue({
        amount: new Intl.NumberFormat().format(value),
        wamount: new Intl.NumberFormat().format(value),
      });
    }
  }, [isOpen, activePaymentType]);

  const handleOrder = (values) => {
    if (saleList && saleList.length > 0) {
      sendOrder({ values, isOrder: true });
    } else {
      owntoast("Бараа байхгүй байна.", "error");
    }
  };

  const getSaleBody = ({ values }) => {
    return {
      discount: saleList.reduce((a, v) => (a = a + v.discount), 0),
      saletype: SaleType.Борлуулалт,
      amount: getSum(),
      changeprice: diffPrice(),
      totalamount: saleList.reduce((a, v) => (a = a + v.totalamount), 0),
      useramount: getPayedSum(),
      cashamount: getAmts(PaymentType.Бэлнээр),
      noncashamount: getAmts(PaymentType.Картаар),
      cashmobile: getAmts(PaymentType.Мобайлаар),
      // payments: payments,

      iscompany: isNoat && values.billType === 3 ? 1 : 0,
      isvat: isNoat ? true : false,
      taxpayername: values.taxpayername,
      taxpayerregno: values.taxpayerregno,
      cards: [],
      details: saleList,
    };
  };

  const getAmts = (ptype) => {
    if (payments) {
      let rs = payments.find((x) => x.type === ptype);
      if (rs) {
        return rs.amount;
      }
    }
    return 0;
  };

  const sendOrder = ({ values }) => {
    setLoading(true);
    let body = getSaleBody({ values });
    props.request({ url: "/sale/sale", body, method: "POST" }).then((res) => {
      setLoading(false);
      if (res.success)
        finishSale({
          type: ReceiptType.Борлуулалт,
          res: { ...res },
          isvat: body.isvat,
        });
      else
        props.setError({
          isOpen: true,
          message: `Борлуулалт хийхэд алдаа гарлаа. ${res.message}`,
        });
    });
  };

  const finishSale = ({ type, res, isvat }) => {
    clearData();
    if (type === ReceiptType.Борлуулалт) {
      setIsOpen(false);
    }
    if (isvat) print({ data: { ...res.data }, type: type });
    owntoast(res.message, "success");
  };

  const clearData = () => {
    setBillType(1);
    modalForm.setFieldsValue({
      billType: 1,
      taxpayerregno: "",
      taxpayername: "",
    });
    props.setActiveTable(null);
    props.removeSaleList("clear");
    setPayments([]);
    setPaymentType(1);
    props.setOrderDetail({
      order: {},
      detail: [],
    });
  };

  useEffect(() => {
    if (order) {
      form.setFieldsValue({
        orderType: order.orderenum,
        deliveryType: order.deliveryenum,
      });
      if (payments && payments.length != 0) {
        setPayments([]);
      }
    }
  }, [order]);

  useEffect(() => {
    let sum = getSum();
    let payedSum = getPayedSum();
    let value = sum - payedSum;
    modalForm.setFieldsValue({
      amount: new Intl.NumberFormat().format(value),
      wamount: new Intl.NumberFormat().format(value),
    });
  }, [payments]);

  const getAmount = (type) => {
    let value = payments.reduce((a, v) => {
      if (v.type === type) {
        return (a = a + v.amount);
      }
      return (a = a + 0);
    }, 0);
    if (value) return value;
    return 0;
  };

  const addPayment = (values) => {
    if (diffPrice(true) >= 0) {
      sendOrder({
        values: { ...modalForm.getFieldsValue(), ...form.getFieldsValue() },
      });
    } else {
      addPaymentList(values.amount);
    }
  };

  const addPaymentList = (amount) => {
    setPayments((prev) => {
      let prevPayment = prev.find((a) => a.type === activePaymentType);
      form.setFieldsValue({ amount: "" });
      if (prevPayment) {
        prevPayment.amount += amount;
        return [...prev];
      }
      return [...prev, { type: activePaymentType, amount: amount }];
    });
  };

  const diffPrice = (isSale) => {
    let diff = getPayedSum() - getSum();
    return isSale ? diff : diff < 0 ? 0 : diff;
  };

  const getPaymentTypeName = () => {
    let res = Object.keys(PaymentType).find(
      (a) => PaymentType[a] === activePaymentType
    );
    return res;
  };

  return (
    <div className="flex-none bg-white p-3 rounded-md">
      <span className="text-grey">Тооцоо</span>
      <Form
        form={form}
        className="grid grid-cols-6 gap-2 mt-2"
        onFinish={handleOrder}
      >
        <div
          className={`${
            orderTypeData[1] || orderTypeData[2]
              ? "sm:col-span-6 md:col-span-6 lg:col-span-3 xl:col-span-3 2xl:cols-span-3"
              : "sm:col-span-6 md:col-span-6 lg:col-span-6 xl:col-span-6 2xl:cols-span-6"
          } border-borderGrey border rounded-md p-2`}
        >
          <div className="flex justify-between items-center font-semibold uppercase">
            <span className="text-grey">Барааны тоо :</span>
            <span className="text-black text-base ">
              {saleList.reduce((a, v) => (a = a + v.qty), 0)}
            </span>
          </div>
          <div className="flex justify-between items-center font-semibold uppercase">
            <span className="text-grey ">Төлөх дүн :</span>
            <span className="text-black text-base ">
              {new Intl.NumberFormat().format(getSum())}
            </span>
          </div>
        </div>
        <Button
          className="col-span-6 flex justify-center font-semibold whitespace-normal h-12"
          type="primary"
          loading={loading}
          onClick={() => {
            if (saleList && saleList.length > 0) {
              setIsOpen(true);
            } else {
              owntoast("Бараа байхгүй байна.", "error");
            }
          }}
        >
          Тооцоо хийх ({new Intl.NumberFormat().format(getSum())})
        </Button>
      </Form>
      <Components.GlobalModal
        footer={null}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        width={500}
        title=" Захиалгын тооцоо хийх "
      >
        <div className="p-3 bg-fullBack">
          <div className="grid grid-cols-6 gap-3">
            <div className="col-span-2 bg-white rounded-sm px-3 py-2">
              <span className="text-grey">Төлбөрийн төрлүүд</span>
              <div className="grid grid-rows-6 gap-2 mt-2">
                {PaymentTypes.map((item, i) =>
                  item.isActive ? (
                    <Components.Ripple
                      key={i}
                      className={` font-semibold ${
                        activePaymentType === item.type ? "active-border" : ""
                      } rounded-xl py-3 flex items-center justify-center`}
                      disabled={disabled}
                      onClick={() => {
                        setPaymentType((prev) => {
                          return item.type;
                        });
                      }}
                    >
                      {item.name}
                    </Components.Ripple>
                  ) : null
                )}
              </div>
            </div>
            <div className="col-span-4 bg-white rounded-sm px-3 py-2 ">
              <span className="text-grey">Төлбөр төлөлт</span>
              <br />
              {/* <Radio.Group
                value={isNoat}
                className="mt-2"
                onChange={(e) => setIsNoat(e.target.value)}
                buttonStyle="solid"
              >
                <Radio.Button value={0}>НӨАТ-гүй</Radio.Button>
                <Radio.Button value={1}>НӨАТ-тэй</Radio.Button>
              </Radio.Group> */}
              <div className="bg-labelGrey grid grid-cols-2 gap-2 mt-2 p-2 uppercase">
                <div className="py-2">Нийт төлөх дүн</div>
                <div className="bg-white p-2 text-right font-bold">
                  {new Intl.NumberFormat().format(getSum())}
                </div>
                {PaymentTypes.map((item, i) =>
                  item.isActive && item.isPayed ? (
                    <>
                      <div className="py-2">
                        {item.cname ? item.cname : item.name}
                      </div>
                      <div className="bg-white p-2 text-right">
                        {new Intl.NumberFormat().format(getAmount(item.type))}
                      </div>
                    </>
                  ) : null
                )}
                <div className="py-2">Нийт төлсөн</div>
                <div className="bg-white p-2 text-right font-bold">
                  {new Intl.NumberFormat().format(getPayedSum())}
                </div>
                <div className="py-2">Хариулт</div>
                <div className="bg-white p-2 text-right">
                  {new Intl.NumberFormat().format(diffPrice())}
                </div>
              </div>
              <Form name="modalForm" form={modalForm} onFinish={addPayment}>
                {diffPrice(true) >= 0 && isNoat ? (
                  <Components.ChooseBilltype
                    form={modalForm}
                    {...props}
                    billType={billType}
                    setBillType={setBillType}
                  />
                ) : (
                 <div> <div className="bg-labelGrey mt-6 flex justify-between rounded active-border">
                    <span className="p-2">{getPaymentTypeName()}:</span>
                    <Components.InputNumberForm
                      name="amount"
                      noStyle
                      required={true}
                      placeholder="Төлөх дүн"
                      max={
                        activePaymentType !== 1
                          ? getSum() - getPayedSum()
                          : 999999999
                      }
                      className="h-full"
                      autoFocus={true}
                      errMsg="Дүн оруулна уу."
                      disabled={disabled}
                    />
                  </div>
                  {activePaymentType === 4 ? (<div className="bg-labelGrey mt-6 flex justify-between rounded active-border">
                    <span className="p-2">Утасны дугаар:</span>
                       <Form.Item name="phone" rules={PHONENO_VALIDATOR}>
            <Input   className="w-36 font-bold text-right pay-input" keyboardType={"numeric"} placeholder="Утасны дугаар" maxLength={8}/>
          </Form.Item>
                    
                  </div>):(null)}</div>
                )}
                <div className="w-full mt-5 flex flex-col">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className={`w-full float-right flex justify-center mt-2`}
                    loading={loading}
                  >
                    {diffPrice(true) >= 0 ? "Төлбөр дуусгах" : "Төлбөр оруулах"}
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </Components.GlobalModal>
      <div className="hidden">
        <SaleBill
          ref={orderRef}
          data={receiptData}
          printqty={props.resprinterconfig && props.resprinterconfig.printqty}
        />
      </div>
    </div>
  );
}

export default OrderPayment;
